import React, { useContext, useEffect, useState } from "react";
import { FaTimes } from "react-icons/fa";
import { PeFilterContext } from "../Contexts/PeFilterContext";

const DefinitionModal = ({ values, onClose, CFSRefine, TagsOptions, setTagsOptions, customPathname }) => {

  const { refineSearchFilters } = useContext(PeFilterContext);
  const [localValues, setLocalValues] = useState({
    non_comp: [],
    comp: [],
    s_tags: []
  });
  const PAGE_SIZE = CFSRefine ?  40 : values.s_tags.length ;
  const [visibleCount, setVisibleCount] = useState({ non_comp: PAGE_SIZE, comp: PAGE_SIZE, s_tags: PAGE_SIZE });

  const sortByName = (list) =>
    [...list].sort((a, b) => (a?.name ?? "").localeCompare(b?.name ?? "", undefined, { sensitivity: "base" }));

  useEffect(() => {
    console.log(values, "tag values");
    
    // Initialize local state with values, setting isChecked based on TagsOptions
    if (values && (values.non_comp || values.comp || values.s_tags)) {
      setLocalValues({
        non_comp: sortByName(values.non_comp?.map(item => {
          const isChecked = TagsOptions?.some(option => option.name === item.name) || false;
          return {
            ...item,
            isChecked
          };
        }) || []),
        comp: sortByName(values.comp?.map(item => {
          const isChecked = TagsOptions?.some(option => option.name === item.name) || false;
          return {
            ...item,
            isChecked
          };
        }) || []),
        s_tags: sortByName(values.s_tags?.map(item => {
          const isChecked = TagsOptions?.some(option => option.name === item.name) || false;
          return {
            ...item,
            isChecked
          };
        }) || [])
      });
    }
  }, [values, TagsOptions, customPathname, refineSearchFilters])

  // Additional useEffect to handle TagsOptions changes specifically
  useEffect(() => {
    console.log("TagsOptions changed in modal:", TagsOptions);
    // Re-sync when TagsOptions changes (from Tags.jsx)
    if (localValues.non_comp.length > 0 || localValues.comp.length > 0 || localValues.s_tags.length > 0) {
      setLocalValues(prev => ({
        non_comp: prev.non_comp.map(item => ({
          ...item,
          isChecked: TagsOptions?.some(option => option.name === item.name) || false
        })),
        comp: prev.comp.map(item => ({
          ...item,
          isChecked: TagsOptions?.some(option => option.name === item.name) || false
        })),
        s_tags: prev.s_tags.map(item => ({
          ...item,
          isChecked: TagsOptions?.some(option => option.name === item.name) || false
        }))
      }));
    }
  }, [TagsOptions])

  const handleTagChange = (tag, isChecked, section) => {
    setLocalValues(prev => ({
      ...prev,
      [section]: prev[section].map(item => 
        item.id === tag.id ? { ...item, isChecked } : item
      )
    }));
  };

  const handleProceed = () => {
    // Collect all checked tags from both sections
    const checkedTags = [
      ...localValues.non_comp.filter(item => item.isChecked),
      ...localValues.comp.filter(item => item.isChecked),
      ...localValues.s_tags.filter(item => item.isChecked)
    ];
    
    // Extract only the names and update TagsOptions with id set to name
    const tagNames = checkedTags.map(tag => tag.name);
    setTagsOptions(tagNames.map(name => ({ id: name, name })));
    
    onClose();
  };


  return (
    <div className='flex font-sans_book_body cursor-default justify-center items-center z-10 fixed left-0 top-0 w-screen h-screen  bg-gray-500 bg-opacity-75 transition-opacity'>
        <div className='flex flex-col w-[95%] md:w-[60%] h-3/4 bg-white rounded-lg border-b gap-2'>
          <div className="py-2 sticky top-1 rounded-t-lg">
              <span onClick={onClose} className="flex justify-end pr-4 pt-2 cursor-pointer">
                  <FaTimes color="grey" />
              </span>
          </div>
          <div className="flex justify-center overflow-auto">
          <div>
            <h1 className="text-black font-medium text-lg text-center">Primary Tags</h1>
            <div className="m-6 grid grid-cols-4 gap-x-4 gap-y-2">
              {localValues?.non_comp?.map(val => 
                <label key={val.id} className="flex items-center p-2 hover:bg-gray-50 rounded cursor-pointer">
                  <input 
                    type="checkbox" 
                    className="mr-2 h-4 w-4 text-blue-600 rounded border border-gray-300 focus:ring-blue-500"
                    checked={val.isChecked}
                    onChange={(e) => handleTagChange(val, e.target.checked, 'non_comp')}
                  />
                  <span className="text-sm">{val.name}</span>
                </label>
              )}
            </div>
          <div className="py-2 rounded-t-lg">
              <h1 className="text-black font-medium text-lg text-center">Secondary Tags</h1>
          </div>
          <div className="m-6 mb-2 grid grid-cols-4 gap-x-4 gap-y-2">
            {localValues?.s_tags?.slice(0, visibleCount.s_tags).map(val => 
              <label key={val.id} className="flex items-center p-2 hover:bg-gray-50 rounded cursor-pointer">
                <input 
                  type="checkbox" 
                  className="mr-2 h-4 w-4 text-blue-600 rounded border border-gray-300 focus:ring-blue-500"
                  checked={val.isChecked}
                  onChange={(e) => handleTagChange(val, e.target.checked, 's_tags')}
                />
                <span className="text-sm">{val.name}</span>
              </label>
            )}
          </div>
          {localValues?.s_tags?.length > visibleCount.s_tags && (
            <div className="flex justify-center mb-2">
              <button
                onClick={() => setVisibleCount(prev => ({ ...prev, s_tags: prev.s_tags + PAGE_SIZE }))}
                className="text-base text-[#BC8B20] hover:underline font-medium"
              >View More</button>
            </div>
          )}
          {!CFSRefine ? (
              <>
                <div className="py-2 rounded-t-lg">
                  <h1 className="text-black font-medium text-lg text-center">
                    Competitor Tags
                  </h1>
                </div>
                <div className="m-6 grid grid-cols-4 gap-x-4 gap-y-2">
                  {localValues?.comp?.map((val) => (
                    <label
                      key={val.id}
                      className="flex items-center p-2 hover:bg-gray-50 rounded cursor-pointer"
                    >
                      <input
                        type="checkbox"
                        className="mr-2 h-4 w-4 text-blue-600 rounded border border-gray-300 focus:ring-blue-500"
                        checked={val.isChecked}
                        onChange={(e) =>
                          handleTagChange(val, e.target.checked, "comp")
                        }
                      />
                      <span className="text-sm">{val.name}</span>
                    </label>
                  ))}
                </div>
              </>
            ) : null}
          </div>
        </div>
        
        {/* Proceed Button */}
        <div className="sticky bottom-0 bg-white border-t p-4 flex justify-center">
          <button 
            onClick={handleProceed}
            className="px-6 py-2 bg-[#BC8B20] text-white rounded-lg hover:bg-[#a67a1b] transition-colors duration-200 font-medium"
          >
            Proceed
          </button>
        </div>
        </div>
    </div>
  );
};

export default DefinitionModal;
